/* eslint-disable @typescript-eslint/no-explicit-any */
// Allowing anys to support port-over tagging code.
import { ITrackingPayload, ITrackAnchorClick } from '../types/analytics';

declare global {
    interface Window {
        adobeDataLayer: ITrackingPayload[];
        digitalData: DigitalData;
        _satellite: any;
    }
}

interface DigitalData {
    page: {
        pageInfo: {
            pageID: string;
        };
    };
}

export const ANALYTICS_CONSTANTS = {
    EVENTS: {
        CLICK: {
            CTA: 'ctaClick',
            SAVE_RECOMMENDED_CAR: 'recommendedSaveCarClick',
            SEARCH_INITIATED: 'searchInitiated',
            RECOMMENDED_CARTILE: 'recommendedCarClicked',
        },
        PAGE: {
            LOAD: 'pageLoad',
            STATE: 'pageState',
        },
        IMPRESSION: {
            RECOMMENDED_CAR: 'recommendedCarImpression',
            VIEWED_VEHICLES: 'viewedVehiclesImpression',
        },
    },
    PAGE_STATE_LOAD_TIME: 2000,
    TRACKING_DELAY: 250,
    RECOMMENDED_SECTION_IDS: [
        'kmx-recommended-carousel',
        'local-cars-carousel',
        'you-might-like',
        'car-recommendations-carousel',
    ],
};

const findPageLoadEvent = () =>
    window.adobeDataLayer.find((x: ITrackingPayload) => x.event === ANALYTICS_CONSTANTS.EVENTS.PAGE.LOAD);

const pageLoadEventTimeout = 60000;

export const trackEDDL = (payload: ITrackingPayload): void => {
    if (payload.event == null) {
        payload.event = ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA;
    }
    // "adobeDataLayer" will appear in the console if the site in questions is using "EDDL"
    // Note: adobeDataLayer is created by Adobe, not us. Thus, we don't create it if it doesn't exist.
    if (window.adobeDataLayer === undefined || !Array.isArray(window.adobeDataLayer)) {
        return;
    }

    let pageLoadEventTimer = 0;
    const pageLoadEvent = findPageLoadEvent();
    if (pageLoadEvent) {
        window.adobeDataLayer.push(payload);
        return;
    }

    const waitForPageLoadEventInterval = setInterval(() => {
        if (pageLoadEventTimer >= pageLoadEventTimeout) {
            clearInterval(waitForPageLoadEventInterval);
            window.adobeDataLayer.push(payload);
            return;
        }

        if (findPageLoadEvent()) {
            clearInterval(waitForPageLoadEventInterval);
            window.adobeDataLayer.push(payload);
            return;
        }

        pageLoadEventTimer += 250;
    }, 250);
};

export const trackAnchorClick = ({
    clickEvent,
    taggingEvent,
    title,
    position,
    href,
    page,
    search,
}: ITrackAnchorClick) => {
    clickEvent.preventDefault();
    const payload: ITrackingPayload = {
        event: taggingEvent,
        linkDetails: {
            name: title,
            position: position,
        },
        search: {
            initiationMethod: search?.initiationMethod ?? `${page}|${title}|${location}`,
        },
    };
    trackEDDL(payload);
    setTimeout(() => {
        window.location.href = href;
    }, ANALYTICS_CONSTANTS.TRACKING_DELAY);
};

export const buildModuleExperience = (pipeSeparatedProps: string, cohortId?: string, testId?: string) => {
    return cohortId && testId ? `${pipeSeparatedProps}:${testId}:${cohortId}` : pipeSeparatedProps;
};
